<div
  class="lc-param-nav-progress"
  [class.lc-param-nav-progress--active]="loading$ | async"
  aria-live="polite"
>
  <div class="lc-param-nav-progress__track">
    <div
      class="lc-param-nav-progress__bar"
      [style.width.%]="progress$ | async"
    ></div>
  </div>
</div>
